// extracted by mini-css-extract-plugin
export default {"wrapper":"PullQuoteSlice_wrapper__OctGD","quote":"PullQuoteSlice_quote__PLAHk"};